
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherAllocateDialog extends Serenity.EntityDialog<GiftVoucherAllocateRow, any> {
        protected getFormKey() { return GiftVoucherAllocateForm.formKey; }
        protected getIdProperty() { return GiftVoucherAllocateRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherAllocateRow.localTextPrefix; }
        protected getNameProperty() { return GiftVoucherAllocateRow.nameProperty; }
        protected getService() { return GiftVoucherAllocateService.baseUrl; }
        protected getDeletePermission() { return GiftVoucherAllocateRow.deletePermission; }
        protected getInsertPermission() { return GiftVoucherAllocateRow.insertPermission; }
        protected getUpdatePermission() { return GiftVoucherAllocateRow.updatePermission; }

        protected form = new GiftVoucherAllocateForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.ItemDetails);
            this.form.CompanyId.changeSelect2(e => {
                this.form.ItemDetails.CompanyId = parseInt(this.form.CompanyId.value);
            });
            this.form.EmployeeId.changeSelect2(e => {
                this.form.ItemDetails.EmployeeId = parseInt(this.form.EmployeeId.value);
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.CompanyId.value != "") {
                this.form.UserId.value = Q.Authorization.userDefinition.UserId.toString();
            }
        }
    }
}